/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * describes the type of a voucher
 * @export
 */
export const VoucherType = {
    Regular: 'REGULAR',
    System: 'SYSTEM'
} as const;
export type VoucherType = typeof VoucherType[keyof typeof VoucherType];


export function VoucherTypeFromJSON(json: any): VoucherType {
    return VoucherTypeFromJSONTyped(json, false);
}

export function VoucherTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoucherType {
    return json as VoucherType;
}

export function VoucherTypeToJSON(value?: VoucherType | null): any {
    return value as any;
}

